import type { SeasonId, SeasonKind } from "@skladiscenje/contracts";

import type { ApiClient } from "./client.js";
import type { WireSeason } from "./types.js";

export function listSeasons(client: ApiClient): Promise<{ seasons: WireSeason[] }> {
  return client.get<{ seasons: WireSeason[] }>("/api/seasons");
}

export interface CloseSeasonBody {
  openSeasonId: SeasonId;
  name: { kind: SeasonKind; year: number };
}

export function closeSeason(
  client: ApiClient,
  body: CloseSeasonBody,
): Promise<{ closed: WireSeason; opened: WireSeason }> {
  return client.post<{ closed: WireSeason; opened: WireSeason }>("/api/seasons/close", body);
}
